import {
  IonButton,
  IonButtons,
  IonCard,
  IonCardHeader,
  IonCardSubtitle,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonModal,
  IonSelect,
  IonSelectOption,
  IonTitle,
  IonToolbar,
  useIonAlert,
  useIonToast,
} from "@ionic/react";
import { filterOutline } from "ionicons/icons";
import { nanoid } from "nanoid";
import React, { useEffect, useState } from "react";
import { useObject } from "react-firebase-hooks/database";
import mergeArray from "../../utils/merge-array";
import { sortVarian } from "../../utils/sort";
import { useFirebase } from "../firebase-provider";
import PageLayout from "../layout";
import Loading from "../loading"

const EditProduct: React.FC<any> = ({ match, history }) => {
  const [modal, setModal] = useState<{ active: boolean; content: any }>({
    active: false,
    content: {},
  });

  const [filter, setFilter] = useState<any>({
    modal: false,
    data: {
      ukuran: "",
      warna: "",
    },
  });


  const [isAddVarian, setAddVarian] = useState(false);

  const [alert] = useIonAlert();
  const [toast] = useIonToast();

  const id = match.params.id;

  const { database } = useFirebase();
  const [snapshots, loading] = useObject(database.ref(`product/${id}`));
  const [snapshotsSku, loadingSku] = useObject(database.ref(`stock`));

  const [sku, setSku] = useState<any>({});
  const [tempStok, setTempStok] = useState(0);

  const [productData, setProductData] = useState<any>({
    category: "Kaos",
    sku: `TPK-${nanoid(4)}`,
    brand: "Tapak Apparel",
    product_name: "",
    price: 0,
    varian: [],
  });

  const [varian, setVarian] = useState<any>({
    sku: `${id}-${nanoid(4)}`,
    price_changes: 0,
    data: { warna: "", ukuran: "" },
  });

  useEffect(() => {
    if (snapshots) {
      setProductData(snapshots.val());
    }
  }, [snapshots]);

  useEffect(() => {
    if (snapshotsSku) {
      setSku(snapshotsSku.val());
    }
  }, [snapshotsSku]);

  // Change Handler
  const handleProductForm = (e: any) =>
    setProductData({
      ...productData,
      [e.target.name]: e.detail.value,
    });
  // HANDLE UPDATE

  const handleUpdate = async () => {
    const setSku = database.ref("stock").set(sku);
    const setProduct = database.ref(`product/${id}`).update(productData);

    await Promise.all([setProduct, setSku])
      .then(() => {
        toast({
          message: "Produk berhasil diperbarui!",
          duration: 3000,
          color: "success",
          position: "top",
        });
        history.push(`/app/product`);
      })
      .catch(() => {
        toast({
          message: "Terjadi Kesalahan! Produk gagal diperbarui!",
          duration: 1000,
          color: "danger",
          position: "top",
        });
      });
  };

  const allVariant = mergeArray(
    productData?.varian?.map((e: any) => Object.keys(e.data || {})).flat()
  ).sort((a, b) => sortVarian(a, b));

  const filteredVarian = productData?.varian?.filter(
    (s: any) =>
      (s.data?.ukuran?.includes(filter?.data?.ukuran) || !s.data?.ukuran) &&
      (s.data?.warna?.includes(filter?.data?.warna) || !s.data?.warna)
  );

  return (
    <>
      <PageLayout title="Edit Produk">
        {(loading || loadingSku) && (
          <Loading />
        )}
        {snapshots && (!loading || !loadingSku) && (
          <>
            <IonCard className="ion-margin-bottom">
              <IonCardHeader>
                <IonCardSubtitle>Merk &amp; Kategori</IonCardSubtitle>
              </IonCardHeader>

              <IonItem>
                <IonLabel position="stacked">Kategori</IonLabel>
                <IonSelect
                  name="category"

                  value={productData?.category}
                  cancelText="Batal"
                  onIonChange={handleProductForm}
                >
                  <IonSelectOption value="Kaos">Kaos</IonSelectOption>
                  <IonSelectOption value="Kaos Anak">Kaos Anak</IonSelectOption>
                  <IonSelectOption value="Jaket/Sweater">
                    Jaket/Sweater
                  </IonSelectOption>
                </IonSelect>
              </IonItem>

              <IonItem lines="none">
                <IonLabel position="stacked">Merk</IonLabel>
                <IonInput
                  name="brand"
                  value={productData?.brand}
                  onIonChange={handleProductForm}
                ></IonInput>
              </IonItem>

              <IonCardHeader>
                <IonCardSubtitle>Rincian Produk</IonCardSubtitle>
              </IonCardHeader>

              <IonItem>
                <IonLabel position="stacked">Nama Produk</IonLabel>
                <IonInput
                  name="product_name"
                  value={productData?.product_name}
                  onIonChange={handleProductForm}
                ></IonInput>
              </IonItem>

              <IonItem>
                <IonLabel position="stacked">SKU (Stock Keeping Unit)</IonLabel>
                <IonInput
                  name="sku"
                  value={productData?.sku}
                  onIonChange={handleProductForm}
                ></IonInput>
              </IonItem>

              <IonItem>
                <IonLabel position="stacked">Harga (IDR)</IonLabel>
                <IonInput
                  name="price"
                  value={productData?.price}
                  type="number"
                  onIonChange={handleProductForm}
                ></IonInput>
              </IonItem>
            </IonCard>

            <IonCard className="ion-margin-bottom">
              <IonToolbar color="primary">
                <IonTitle>Varian</IonTitle>
                <IonButtons slot="end">
                  <IonButton
                    onClick={() => setFilter({ ...filter, modal: true })}
                  >
                    <IonIcon icon={filterOutline} size="large" />
                  </IonButton>
                </IonButtons>
              </IonToolbar>
              {/* {isVariant && varianForm()} */}

              {productData?.varian.length >= 1 &&
                filteredVarian.map((e: any, i: number) => {
                  return (
                    <React.Fragment key={e.sku}>
                      <IonItem
                        lines="full"
                        button
                        onClick={() => {
                          setModal({
                            active: true,
                            content: { data: e, index: i },
                          });
                          setTempStok(sku[e.sku]);
                        }}
                      >
                        {e.data && (
                          <IonLabel color="medium">
                            {Object.values(e.data).join(" / ")}
                          </IonLabel>
                        )}
                        <IonLabel slot="end">Stok: {sku[e.sku]}</IonLabel>
                        <IonLabel slot="end">
                          {new Intl.NumberFormat("id-ID", {
                            style: "currency",
                            currency: "IDR",
                            maximumSignificantDigits: 10,
                          }).format(Number(productData.price)+Number(e.price_changes))}
                        </IonLabel>
                      </IonItem>
                    </React.Fragment>
                  );
                })}
              <IonButton
                className="ion-margin-top ion-margin-bottom"
                fill="clear"
                color="dark"
                size="small"
                onClick={() => setAddVarian(true)}
              >
                Tambah Varian Lain
              </IonButton>
            </IonCard>

            {isAddVarian && (
              <IonCard>
                <IonCardHeader>
                  <IonCardSubtitle>Tambah Varian</IonCardSubtitle>
                </IonCardHeader>
                <IonItemGroup>

                  <IonItem>
                    <IonLabel position="stacked">Perubahan Harga</IonLabel>

                    <IonInput
                      value={varian.price_changes || 0}
                      type="number"
                      onIonChange={(event) =>
                        setVarian({ ...varian, price_changes: event.detail.value })
                      }
                    ></IonInput>
                  </IonItem>
                  <IonItem>
                    <IonLabel position="stacked">Stok</IonLabel>
                    <IonInput
                      value={tempStok}
                      type="number"
                      onIonChange={(event) =>
                        setTempStok(Number(event.detail.value))
                      }
                    ></IonInput>
                  </IonItem>

                  {Object.keys(varian.data).map((e: string) => {
                    return (
                      <React.Fragment key={e}>
                        <IonItem>
                          <IonLabel position="stacked">
                            {e.charAt(0).toLocaleUpperCase() + e.slice(1)}
                          </IonLabel>
                          <IonInput
                            name={e}
                            value={varian.data[e]}
                            onIonChange={(ev) => {
                              setVarian({
                                ...varian,
                                data: { ...varian.data, [e]: ev.detail.value },
                               
                              });
                            }}
                            onIonBlur={(ev) => {
                              setVarian({
                                ...varian,
                          
                                sku: `${id}-${
                                  Object.values(varian.data).join("-")
                                    .toUpperCase()
                                }`,
                              });
                            }}
                          ></IonInput>
                         
                        </IonItem>
                      </React.Fragment>
                    );
                  })}
                </IonItemGroup>
                <br />
                <IonButton
                  className="ion-margin"
                  onClick={() => {
                    let newData = [...productData?.varian];
                    newData.push(varian);
                    if (
                      productData?.varian.filter(
                        (el: any) => el.data === varian.data
                      ).length < 1
                    ) {
                      setProductData({ ...productData, varian: newData });
                      setSku({ ...sku, [varian.sku]: tempStok });
                      setVarian({
                        ...varian,
                        sku: `${productData?.sku}-${nanoid(4)}`,
                      });
                      setAddVarian(false);
                      toast({
                        message: "Varian berhasil ditambahkan!",
                        duration: 1000,
                        color: "success",
                        position: "top",
                      });
                    } else {
                      toast({
                        message: "Varian sudah ada!",
                        duration: 1000,
                        color: "warning",
                        position: "top",
                      });
                    }
                  }}
                >
                  Buat Varian Baru
                </IonButton>
              </IonCard>
            )}

            {/* MODAL */}
            {/* FILTER MODAL */}

            <IonModal
              isOpen={filter.modal}
              onDidDismiss={() => setFilter({ ...filter, modal: false })}
            >
              <IonHeader translucent>
                <IonToolbar>
                  <IonTitle>Filter Varian</IonTitle>
                  <IonButtons slot="end">
                    <IonButton
                      onClick={() => setFilter({ ...filter, modal: false })}
                    >
                      Tutup
                    </IonButton>
                  </IonButtons>
                </IonToolbar>
              </IonHeader>
              <IonContent>
                {allVariant?.map((data) => {
                  return (
                    <React.Fragment key={data}>
                      <IonItem>
                        <IonLabel position="stacked">
                          {data.charAt(0).toLocaleUpperCase() + data.slice(1)}
                        </IonLabel>
                        <IonSelect
                          value={filter?.data[data]}
                          onIonChange={(el) =>
                            setFilter({
                              ...filter,
                              data: { ...filter.data, [data]: el.detail.value },
                            })
                          }
                          placeholder={`Pilih ${data}`}
                        >
                          <IonSelectOption value="">
                            {`Pilih ${data}`}
                          </IonSelectOption>
                          {mergeArray(
                            productData?.varian?.map((x: any) => x.data[data])
                          ).map((vrn) => (
                            <React.Fragment key={vrn}>
                              <IonSelectOption value={vrn}>
                                {vrn}
                              </IonSelectOption>
                            </React.Fragment>
                          ))}
                        </IonSelect>
                      </IonItem>
                    </React.Fragment>
                  );
                })}
              </IonContent>
              <IonFooter translucent>
                <IonToolbar>
                  <IonButtons slot="end">
                    <IonButton
                      onClick={() => setFilter({ ...filter, modal: false })}
                    >
                      Atur Filter
                    </IonButton>
                  </IonButtons>
                </IonToolbar>
              </IonFooter>
            </IonModal>

            <IonModal
              isOpen={modal.active}
              swipeToClose={true}
              onDidDismiss={() => {
                setModal({ active: false, content: "" });
                setTempStok(0);
              }}
            >
              <IonHeader translucent>
                <IonToolbar>
                  <IonTitle>Edit varian</IonTitle>
                  <IonButtons slot="end">
                    <IonButton
                      onClick={() => setModal({ active: false, content: "" })}
                    >
                      Tutup
                    </IonButton>
                  </IonButtons>
                </IonToolbar>
              </IonHeader>
              <IonContent>
                <IonItemGroup>
                  <IonItemDivider className="ion-margin-top">
                    <IonLabel color="primary">Varian</IonLabel>
                  </IonItemDivider>
                  {(modal?.content?.data?.data
                    ? Object.keys(modal.content.data.data)
                    : []
                  ).map((e: string) => (
                    <React.Fragment key={e}>
                      <IonItem>
                        <IonLabel position="stacked">
                          {e.charAt(0).toLocaleUpperCase() + e.slice(1)}
                        </IonLabel>
                        <IonInput
                          value={modal.content.data.data[e]}
                          onIonChange={(event) =>
                            setModal({
                              ...modal,
                              content: {
                                ...modal.content,
                                data: {
                                  ...modal.content.data,
                                  data: {
                                    ...modal.content.data.data,
                                    [e]: event.detail.value,
                                  },
                                },
                              },
                            })
                          }
                        ></IonInput>
                      </IonItem>
                    </React.Fragment>
                  ))}

                  <IonItemDivider className="ion-margin-top">
                    <IonLabel color="primary">Rincian Produk</IonLabel>
                  </IonItemDivider>

                  <IonItem>
                    <IonLabel position="stacked">SKU</IonLabel>
                    <IonInput
                      value={modal?.content?.data?.sku || ""}
                      onIonChange={(event) =>
                        setModal({
                          ...modal,
                          content: {
                            ...modal.content,
                            data: {
                              ...modal.content.data,
                              sku: event.detail.value,
                            },
                          },
                        })
                      }
                    ></IonInput>
                  </IonItem>

                  <IonItem>
                    <IonLabel position="stacked">Perubahan Harga</IonLabel>

                    <IonInput
                      value={modal?.content?.data?.price_changes || 0}
                      type="number"
                      onIonChange={(event) =>
                        setModal({
                          ...modal,
                          content: {
                            ...modal.content,
                            data: {
                              ...modal.content.data,
                              price_changes: event.detail.value,
                            },
                          },
                        })
                      }
                    ></IonInput>
                  </IonItem>
                  <IonItem>
                    <IonLabel position="stacked">Stok</IonLabel>
                    <IonInput
                      value={tempStok || 0}
                      type="number"
                      onIonChange={(event) =>
                        setTempStok(Number(event.detail.value))
                      }
                    ></IonInput>
                  </IonItem>
                </IonItemGroup>
              </IonContent>
              <IonFooter translucent>
                <IonToolbar>
                  <IonButton
                    className="ion-margin"
                    color="primary"
                    disabled={
                      productData?.varian[modal?.content?.index] ===
                        modal?.content?.data &&
                      (sku[modal?.content?.data?.sku] || "") === tempStok
                    }
                    onClick={() => {
                      let newVariant = [...productData?.varian];
                      let index = productData?.varian?.findIndex(
                        (el: any) => el.sku === modal?.content?.data?.sku
                      );
                      setSku({ ...sku, [modal?.content?.data?.sku]: tempStok });

                      newVariant[index] = modal.content.data;

                      setProductData({ ...productData, varian: newVariant });
                      setModal({ active: false, content: "" });
                      setTempStok(0);
                    }}
                  >
                    Simpan
                  </IonButton>

                  <IonButton
                    className="ion-margin"
                    color="danger"
                    fill="clear"
                    onClick={() =>
                      alert({
                        header: "Hapus Varian",
                        message: "Yakin ingin hapus varian ini?",
                        buttons: [
                          {
                            text: "Tidak",
                            handler: () =>
                              setModal({ active: false, content: "" }),
                          },
                          {
                            text: "Iya",
                            handler: () => {
                              // Hapus SKU
                              let newSku = { ...sku };
                              delete newSku[modal?.content?.data?.sku];
                              setSku(newSku);

                              // Hapus Varian
                              let newVariant = [...productData?.varian].filter(
                                (e, i) => i !== modal.content.index
                              );
                              setProductData({
                                ...productData,
                                varian: newVariant,
                              });
                              setModal({ active: false, content: "" });
                              toast({
                                message: "Varian berhasil dihapus",
                                duration: 1000,
                                color: "danger",
                                position: "top",
                              });
                            },
                          },
                        ],
                      })
                    }
                  >
                    Hapus Varian
                  </IonButton>
                </IonToolbar>
              </IonFooter>
            </IonModal>

            <IonButton
              className="ion-margin"
              onClick={handleUpdate}
              fill="outline"
              color="dark"
            >
              Perbarui Produk
            </IonButton>
          </>
        )}
      </PageLayout>
    </>
  );
};

export default EditProduct;
